import { ComponentType } from '@angular/cdk/overlay';
import { computed, inject, Injectable, Signal, signal, WritableSignal } from '@angular/core';

import { AbstractFilterMenuComponent } from '@connect-services/client/components/abstract-filter-menu/abstract-filter-menu.component';
import { FieldInterventionEntitiesFilterComponent } from '@connect-services/client/components/filter-menu/filter-menu-content/field-intervention-entities-filter/field-intervention-entities-filter.component';
import { MapFilterComponent } from '@connect-services/client/components/filter-menu/filter-menu-content/map-filter/map-filter.component';
import { FieldInterventionEntitiesFilterService } from '@connect-services/client/services/field-intervention-entities-filter.service';
import { FilterService, FilterTypeEnum } from '@connect-services/client/services/filter.service';
import { MapFilterService } from '@connect-services/client/services/map-filter.service';

export type FilterMapping = {
    component: ComponentType<AbstractFilterMenuComponent>;
    service: FilterService<unknown>;
};

@Injectable({
    providedIn: 'root',
})
export class FilterResolverService {
    public readonly currentComponent: Signal<ComponentType<AbstractFilterMenuComponent> | undefined> = computed(() => {
        if (!this.currentFilterType()) {
            return;
        }

        return this.filterMap[this.currentFilterType()!].component;
    });
    public readonly currentFilterType: WritableSignal<FilterTypeEnum | null> = signal(null);
    public readonly currentService: Signal<FilterService<unknown> | null> = computed(() => {
        if (!this.currentFilterType()) {
            return null;
        }

        return this.filterMap[this.currentFilterType()!].service;
    });

    private readonly fieldInterventionEntitiesFilterService = inject(FieldInterventionEntitiesFilterService);
    private readonly mapFilterService = inject(MapFilterService);

    // eslint-disable-next-line @typescript-eslint/member-ordering
    private readonly filterMap: Record<FilterTypeEnum, FilterMapping> = {
        [FilterTypeEnum.FIELD_INTERVENTION_ENTITIES]: {
            component: FieldInterventionEntitiesFilterComponent,
            service: this.fieldInterventionEntitiesFilterService,
        },
        [FilterTypeEnum.MAP_ENTITIES]: {
            component: MapFilterComponent,
            service: this.mapFilterService,
        },
    };

    public reset(): void {
        this.currentService()?.reset();
    }
}
